import BaseFeature from '../../foundation/base/base';

class SearchWithTags extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;

		this.searchInput = this.el.querySelector('[data-ref="search-with-tags__input"]');
		this.submitButton = this.el.querySelector('[data-ref="search-with-tags__button"]');

		this.addEventListener();
		this.activateSearchButton();
		this.log('Search With Tags');
	}

	addEventListener() {
		this.searchInput.addEventListener('keyup', () => {
			this.activateSearchButton();
		});
	}

	activateSearchButton() {
		if (this.searchInput.value.length > 0) {
			this.submitButton.classList.remove('m-link-icon--button-disabled');
			this.submitButton.removeAttribute('disabled');
			this.submitButton.setAttribute('tabindex', '0');
		}
		if (this.searchInput.value.length <= 0) {
			this.submitButton.classList.add('m-link-icon--button-disabled');
			this.submitButton.setAttribute('disabled', 'disabled');
			this.submitButton.setAttribute('tabindex', '1');
		}
	}
}

export default SearchWithTags;
